import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "nn-privacy-notice-dismissed-v1";

export default function PrivacyNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      // localStorage blocked (private mode etc.) — stay hidden rather than show every nav.
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="privacy-notice" role="region" aria-label="Privacy notice">
      <div className="privacy-notice-body">
        <strong>No trackers, no behavioural ads.</strong>{" "}
        Just login and security cookies.{" "}
        <Link to="/cookies" onClick={dismiss}>Cookie policy</Link>.
      </div>
      <button type="button" className="privacy-notice-close" onClick={dismiss} aria-label="Dismiss">
        Got it
      </button>
    </div>
  );
}
